<ui-section>
    <ui-section-content>
        <div class="grid-container grid-12 pb-4">
            <ui-field class="grid-span-3" [label]="'PAGES.BUSINESS_INDICATORS.INDICATOR_SELECTOR' | translate">
                <ui-select [options]="businessIndicatorsIds()" [required]="true" [(ngModel)]="selectedBusinessIndicatorId">
                    <ng-template let-option="option">{{ (option | businessIndicator)?.name }}</ng-template>
                </ui-select>
            </ui-field>
            <ui-toggle class="grid-span-2" [label]="'WIDGET.DISPLAY_ESTIMATED' | translate" [(ngModel)]="isEstimated" />
            <ui-field class="grid-span-2" [label]="'TAILORED_WIDGET.INDICATOR_ADVANCEMENT.TITLE' | translate">
                <input advizeoInput [required]="true" [(ngModel)]="title" />
            </ui-field>
            <ui-toggle
                class="grid-span-2"
                [label]="'TAILORED_WIDGET.INDICATOR_ADVANCEMENT.DISPLAY_LEGEND' | translate"
                [(ngModel)]="displayLegend"
            />
        </div>
    </ui-section-content>
</ui-section>
